import {LANDING_PAGE_ROUTE_MAP} from "../CourseConstants";
import { getCurrentCourse} from "../CourseUtility";

const redirectToLandingPageStrategy = () => {
    window.open(process.env.REACT_APP_FRONTEND_MAIN_URL+`${LANDING_PAGE_ROUTE_MAP[getCurrentCourse()]}`,"_self")
};

export default redirectToLandingPageStrategy;
